// Quien puede inscribir un grupo a un torneo y capturar sus juegos.
//
// Espeja `puede_capturar_juegos(grupo_id)` de la base. Si los dos lados se separan, vuelve
// el defecto que esto viene a cerrar: botones que prometen lo que la base va a rechazar.
// Cualquier cambio aqui va tambien alla, y al reves.
//
// Desde 20260910 la base mira SOLO el rol EN EL GRUPO, no la ficha de la persona:
// `staff.rol` es un cache de la membresia PRINCIPAL, asi que en el grupo de otra
// organizacion contestaba por la organizacion equivocada. Que estes asignado ya dice que
// perteneces; el rol en el grupo dice que haces ahi.
const ROLES_EN_GRUPO = new Set(['manager', 'head coach', 'coach', 'assistant', 'asistente'])

export const puedeCapturarJuegos = ({
  rol = null,
  esPlatformAdmin = false,
  asignaciones = [],
  grupoId = null,
} = {}) => {
  if (esPlatformAdmin) return true
  // PENDIENTE (bloque del cliente): `rol` viene de `staff.rol`, la ficha. Deberia ser la
  // MEMBRESIA en la org activa, como hace la base con `is_org_admin(org_id)`. Se conserva
  // por ahora para no cerrarle la puerta a un admin mientras `usePermissions` sigue
  // leyendo la ficha; el dia que lea la membresia, esta linea se queda correcta sola.
  if (rol === 'admin') return true
  if (!grupoId) return false

  return (asignaciones || []).some((a) => {
    if (!a || a.activo === false) return false
    if ((a.grupo_id || a.id) !== grupoId) return false
    return ROLES_EN_GRUPO.has(String(a.rol || '').toLowerCase())
  })
}
